export default __webpack_public_path__ + "static/media/025-treasure-map.7037a0fa.png";